import { ComponentConfig } from '@boels/models';

export const componentsConfig: ComponentConfig[] = [
  {
    cmsComponentTypeCode: 'BackgroundContentHeaderComponent',
    component: () =>
      import('../content-header/content-header.component').then(
        (it) => it.ContentHeaderComponent,
      ),
  },
  {
    cmsComponentTypeCode: 'ImageContentHeaderComponent',
    component: () =>
      import('../content-header/content-header.component').then(
        (it) => it.ContentHeaderComponent,
      ),
  },
  {
    cmsComponentTypeCode: 'ParagraphComponentOneColumn',
    component: () =>
      import('../paragraph/paragraph.component').then(
        (it) => it.ParagraphComponent,
      ),
  },
  {
    cmsComponentTypeCode: 'ParagraphComponentTwoColumn',
    component: () =>
      import('../text-two-column/text-two-column.component').then(
        (it) => it.TextTwoColumnComponent,
      ),
  },
  {
    cmsComponentTypeCode: 'ContactDetailsComponent',
    component: () =>
      import('../contact-details/contact-details.component').then(
        (it) => it.ContactDetailsComponent,
      ),
  },
  {
    cmsComponentTypeCode: 'SubcategoriesComponent',
    component: () =>
      import('../subcategories/subcategories.component').then(
        (it) => it.SubcategoriesComponent,
      ),
  },
  {
    cmsComponentTypeCode: 'CMSParagraphComponent',
    component: () =>
      import('../paragraph/paragraph.component').then(
        (it) => it.ParagraphComponent,
      ),
  },
  {
    cmsComponentTypeCode: 'SimpleResponsiveBannerComponent',
    component: () =>
      import(
        '../banners-with-media-container/simple-banner/simple-banner.component'
      ).then((it) => it.SimpleBannerComponent),
  },
  {
    cmsComponentTypeCode: 'SimpleBannerComponent',
    component: () =>
      import(
        '../banners-with-media-container/simple-banner/simple-banner.component'
      ).then((it) => it.SimpleBannerComponent),
  },
  {
    cmsComponentTypeCode: 'ProductRefinementComponent',
    component: () =>
      import('../product-filter/product-filter.component').then(
        (it) => it.ProductFilterComponent,
      ),
  },
  {
    cmsComponentTypeCode: 'CMSProductListComponent',
    component: () =>
      import('../product-grid/product-grid.component').then(
        (it) => it.ProductGridComponent,
      ),
  },
  {
    cmsComponentTypeCode: 'CMSFlexComponent',
    component: () =>
      import('../toggle-user-type/toggle-user-type.component').then(
        (it) => it.ToggleUserTypeComponent,
      ),
  },
  {
    cmsComponentTypeCode: 'CMSLinkComponent',
    component: () =>
      import('../link/link.component').then((it) => it.LinkComponent),
  },
  {
    cmsComponentTypeCode: 'HomepageHeroComponent',
    component: () =>
      import('../homepage-hero/homepage-hero.component').then(
        (it) => it.HomepageHeroComponent,
      ),
  },

  {
    cmsComponentTypeCode: 'CardsGroupComponent',
    component: () =>
      import('../cards/cards/cards.component').then((it) => it.CardsComponent),
  },

  {
    cmsComponentTypeCode: 'HorizontalUSPComponent',
    component: () =>
      import('../usp/usp.component').then((it) => it.UspComponent),
    inputs: {
      direction: 'horizontal',
    },
  },

  {
    cmsComponentTypeCode: 'VerticalUSPComponent',
    component: () =>
      import('../usp/usp.component').then((it) => it.UspComponent),
    inputs: {
      direction: 'vertical',
    },
  },

  {
    cmsComponentTypeCode: 'TeasersGroupComponent',
    component: () =>
      import('../cards/teasers/teasers.component').then(
        (it) => it.TeasersComponent,
      ),
  },

  {
    cmsComponentTypeCode: 'SplitBannerComponent',
    component: () =>
      import('../split-banner/split-banner.component').then(
        (it) => it.SplitBannerComponent,
      ),
  },

  {
    cmsComponentTypeCode: 'SmallBannersComponent',
    component: () =>
      import('../small-banner-group/small-banner-group.component').then(
        (it) => it.SmallBannerGroupComponent,
      ),
  },

  {
    cmsComponentTypeCode: 'LogoRotatorComponent',
    component: () =>
      import('../logo-rotator/logo-rotator.component').then(
        (it) => it.LogoRotatorComponent,
      ),
  },

  {
    cmsComponentTypeCode: 'ImageTextComponent',
    component: () =>
      import('../image-text/image-text.component').then(
        (it) => it.ImageTextComponent,
      ),
  },

  {
    cmsComponentTypeCode: 'CMSImageComponent',
    component: () =>
      import('../image/image.component').then((it) => it.ImageComponent),
  },

  {
    cmsComponentTypeCode: 'CTAContactComponent',
    component: () =>
      import('../cta/cta.component').then((it) => it.CtaComponent),
  },

  {
    cmsComponentTypeCode: 'CtaComponent',
    component: () =>
      import('../cta/cta.component').then((it) => it.CtaComponent),
  },
  {
    cmsComponentTypeCode: 'ButtonCMSLinkComponent',
    component: () =>
      import('../primary-button/primary-button.component').then(
        (it) => it.PrimaryButtonComponent,
      ),
  },

  {
    cmsComponentTypeCode: 'AlertMessageComponent',
    component: () =>
      import('../global-message/global-message.component').then(
        (it) => it.GlobalMessageComponent,
      ),
  },

  {
    cmsComponentTypeCode: undefined,
    component: () =>
      import('../usp/usp.component').then((it) => it.UspComponent),
  },

  {
    cmsComponentTypeCode: 'FullWidthBannerComponent',
    component: () =>
      import(
        '../banners-with-media-container/full-width-banner/full-width-banner.component'
      ).then((it) => it.FullWidthBannerComponent),
  },

  {
    cmsComponentTypeCode: 'VideoTextComponent',
    component: () =>
      import('../youtube-video/youtube-video.component').then(
        (it) => it.YoutubeVideoComponent,
      ),
  },

  {
    cmsComponentTypeCode: 'PrivateBusinessToggleComponent',
    component: () =>
      import('../toggle-user-type/toggle-user-type.component').then(
        (it) => it.ToggleUserTypeComponent,
      ),
  },

  {
    cmsComponentTypeCode: 'cookieDeclarationScriptInjectorComponent',
    component: () =>
      import('../injectors/cookie-declaration-script-injector.component').then(
        (it) => it.CookieDeclarationScriptInjectorComponent,
      ),
  },

  {
    cmsComponentTypeCode: 'CartComponent',
    component: () =>
      import('../shopping-cart/shopping-cart/shopping-cart.component').then(
        (it) => it.ShoppingCartComponent,
      ),
  },

  {
    cmsComponentTypeCode: 'SelectLoginAccountComponent',
    component: () =>
      import(
        '../checkout/checkout-account-select/checkout-account-select.component'
      ).then((it) => it.CheckoutAccountSelectComponent),
  },

  {
    cmsComponentTypeCode: 'CartSuggestionComponent',
    component: () =>
      import('../cart-reference/cart-suggestions.component').then(
        (it) => it.CartSuggestionsComponent,
      ),
  },
  {
    cmsComponentTypeCode: 'CheckoutPaymentDetails',
    component: () =>
      import(
        '../checkout/checkout-customer-details/checkout-customer-details.component'
      ).then((it) => it.CheckoutCustomerDetailsComponent),
  },

  {
    cmsComponentTypeCode: 'CheckoutShippingAddress',
    component: () =>
      import('../checkout/checkout-delivery/checkout-delivery.component').then(
        (it) => it.CheckoutDeliveryComponent,
      ),
  },

  {
    cmsComponentTypeCode: 'CheckoutPickup',
    component: () =>
      import('../checkout/checkout-pick-up/checkout-pick-up.component').then(
        (it) => it.CheckoutPickUpComponent,
      ),
  },

  {
    cmsComponentTypeCode: 'CheckoutDeliveryMode',
    component: () =>
      import(
        '../checkout/checkout-delivery-mode/checkout-delivery-mode.component'
      ).then((it) => it.CheckoutDeliveryModeComponent),
  },

  {
    cmsComponentTypeCode: 'CheckoutProgress',
    component: () =>
      import('../checkout/checkout-step/checkout-step.component').then(
        (it) => it.CheckoutStepComponent,
      ),
  },

  {
    cmsComponentTypeCode: 'CheckoutReviewOrder',
    component: () =>
      import(
        '../checkout/checkout-review-and-confirmation/checkout-review.component'
      ).then((it) => it.CheckoutReviewComponent),
  },

  {
    cmsComponentTypeCode: 'OrderConfirmationOverviewComponent',
    component: () =>
      import(
        '../checkout/checkout-review-and-confirmation/checkout-confirmation.component'
      ).then((it) => it.CheckoutConfirmationComponent),
  },

  {
    cmsComponentTypeCode: 'ContactFormComponent',
    component: () =>
      import('../customer-contact/customer-contact.component').then(
        (it) => it.CustomerContactComponent,
      ),
  },

  {
    cmsComponentTypeCode: 'RentOnAccountFormComponent',
    component: () =>
      import('../rent-on-account-form/rent-on-account-form.component').then(
        (it) => it.RentOnAccountFormComponent,
      ),
  },

  {
    cmsComponentTypeCode: 'QuotationFormSiteAccommodationsComponent',
    component: () =>
      import('../quote-form/quote-form.component').then(
        (it) => it.QuoteFormComponent,
      ),
  },
  {
    uid: 'ProductIntroComponent',
    component: () =>
      import('../product-intro/product-intro.component').then(
        (it) => it.ProductIntroComponent,
      ),
  },
  {
    uid: 'ProductImagesComponent',
    component: () =>
      import('../product_image/product-images/product-images.component').then(
        (it) => it.ProductImagesComponent,
      ),
  },
  {
    uid: 'ProductSummaryComponent',
    component: () =>
      import('../product-summary/product-summary.component').then(
        (it) => it.ProductSummaryComponent,
      ),
  },
  {
    uid: 'VariantSelector',
    component: () =>
      import(
        '../product-variant-selector/product-variant-selector.component'
      ).then((it) => it.ProductVariantSelectorComponent),
  },
  {
    uid: 'TabPanelContainer',
    component: () =>
      import('../product-tab/tab-paragraph-container.component').then(
        (it) => it.TabParagraphContainerComponent,
      ),
  },
  {
    cmsComponentTypeCode: 'CategorySiblingNavigationComponent',
    component: () =>
      import(
        '../category-sibling-navigation/category-sibling-navigation.component'
      ).then((it) => it.CategorySiblingNavigationComponent),
  },
  {
    cmsComponentTypeCode: 'SearchResultsListComponent',
    component: () =>
      import('../product-grid/product-grid.component').then(
        (it) => it.ProductGridComponent,
      ),
  },
];
